import { root, id } from './summary';

export const summary = {
  ...root,
  id,
};
